import { HttpContextToken } from '@angular/common/http';

// Use for any HTTP requests that do not work with TokenInterceptor
// (ex. Google Places API)
export const SKIP_TOKEN_INTERCEPTOR = new HttpContextToken<boolean>(
  () => false,
);
